import { BackendHttpService } from "../../../services/backendHttpService";
import { CertificateReportAllIdsRequest, CertificateReportPagedResult, CertificateReportSearchRequest } from "../models/certificateReport.model";

export class CertificateReportService extends BackendHttpService {
  constructor() {
    super("api/reports/certificates");
  }

  search(request: CertificateReportSearchRequest): Promise<CertificateReportPagedResult> {
    return this.post<CertificateReportSearchRequest, CertificateReportPagedResult>(request, "/search");
  }

  /** Every matching PersonId, unpaged — backs "Export CV for all matching." */
  getMatchingPersonIds(request: CertificateReportAllIdsRequest): Promise<number[]> {
    return this.post<CertificateReportAllIdsRequest, number[]>(request, "/search/all-ids");
  }

  /** The full matching set (not just the current page) as an .xlsx or .csv file. */
  async exportFile(request: CertificateReportAllIdsRequest, format: "xlsx" | "csv"): Promise<Blob> {
    const accessToken = await this.getAccessToken();

    const response = await fetch(this.buildUrl(`/export?format=${format}`), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.blob();
  }
}

export const certificateReportService = new CertificateReportService();
